import { apiRequest, ResultAPI } from 'app/requests/apiRequest';
import { buildParams } from 'app/utils/pagination';
import * as commonApi from './commons';
import { Blog } from 'types/blog';

export const getBlogs = async (params) => {
  const path = `/api/blogs${buildParams(params)}`;
  const blogs = await apiRequest(path, 'get');
  return blogs;
};

export const getBlogsSitemap = async (params) => {
  const path = `/api/blogs_sitemap${buildParams(params)}`;
  const blogs = await apiRequest(path, 'get');
  return blogs;
};

export const getNewSlug = async (params) => {
  try {
    const paramsUrl = buildParams(params);
    const result = await apiRequest(`/api/blogs_new_slug${paramsUrl}`, 'get') as ResultAPI;
    return result.data;
  } catch (error) {
    console.error(error?.message);
  }
};

export const getBlogsFooter = async (code: string = 'vi') => {
  const cacheKey = `blogs_footer_${code}`;
  const path = `/api/blogs_footer${buildParams({ code })}`;

  const blogs = await commonApi.list(cacheKey, path);
  return blogs?.data as Blog[];
};

export const getBlogsMenu = async (code: string = 'vi') => {
  const cacheKey = `blogs_right_${code}`;
  const path = `/api/blogs_menu${buildParams({ code })}`;

  const blogs = await commonApi.list(cacheKey, path);
  return blogs?.data as Blog[];
};

export const getBySlug = async (slug: string, code: string) => {
  const cacheKey = `blogs_info_${code}:${slug}`;
  const path = `/api/blogs/${slug}${buildParams({ code })}`;

  const blog = await commonApi.list(cacheKey, path);
  return blog?.data;
};
